import { Setting } from "@/modules/profile/pages/setting";
import { createFileRoute, notFound } from "@tanstack/react-router";
import {
  getDistributorProfileOptions,
  getDistributorBankDetailsOptions,
  getDistributorNomineeDetailsOptions,
  getDistributorPreferencesOptions,
  getUserOptions,
} from "creso-core/hooks";
import { isEmployeeUser } from "creso-core/utils";

function SettingRoute() {
  return <Setting />;
}

export const Route = createFileRoute("/(auth)/_headed/account/setting")({
  component: SettingRoute,
  loader: async ({ context }) => {
    const { queryClient } = context;
    const user = await queryClient.ensureQueryData(getUserOptions());
    if (isEmployeeUser(user.user_type)) {
      throw notFound({ routeId: "__root__" });
    }
    const [profile, banks, nominee, preferences] = await Promise.allSettled([
      queryClient.fetchQuery(getDistributorProfileOptions()),
      queryClient.fetchQuery(getDistributorBankDetailsOptions()),
      queryClient.fetchQuery(getDistributorNomineeDetailsOptions()),
      queryClient.fetchQuery(getDistributorPreferencesOptions()),
    ]);
    return {
      profile: profile.status === "fulfilled" ? profile.value : null,
      banks: banks.status === "fulfilled" ? banks.value : null,
      nominee: nominee.status === "fulfilled" ? nominee.value : null,
      preferences:
        preferences.status === "fulfilled" ? preferences.value : null,
    };
  },
});
